<template>
  <div class="row">
    <div class="col-sm-12">
      <card>
        <!--Card Header-->
        <template slot="header">
          <h3 class="mb-0">
            Cargar Imágenes Lote: <span class="text-muted">{{ resource.title }}</span>
          </h3>
        </template>

        <div class="row justify-content-center">
          <div class="col-md-8">
            <image-uploader
              ref="imageUploader"
              :images="pictures"
              @reset="reset"
              @remove:image="removeImage"
              @add:image="addImage"
              @upload="upload"
            />
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import ImageUploader from '@/views/Plots/Widgets/ImageUploader';

export default {
  name: 'PlotImagesForm',
  components: {
    ImageUploader,
  },

  props: {
    resource: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          prop: null,
          title: '',
        };
      },
    },
  },

  data() {
    return {
      pictures: [],
    };
  },

  methods: {
    addImage(image) {
      this.pictures.push(image);
    },

    removeImage(index) {
      this.pictures.splice(index, 1);
    },

    reset() {
      this.pictures = [];
    },

    upload() {
      if (!this.resource.id) return;

      this.$services
        .resource(this.resource.name)
        .attach(this.resource.id, this.pictures)
        .then((res) => res.data.data)
        .then((data) => {
          this.reset();
          this.$refs.imageUploader.resetStats();
          this.$emit('fetchPictures', this.resource.id, this.resource.name, this.resource.prop);
        })
        .catch((e) => {});
    },
  },
};
</script>
